const noCard = function(action, mediaId, stub) {
    // TODO: This logic is completely buggy and wrong
    const forwardUrl = stub.replace(encodeURIComponent('?no-linked-card=true'), '').replace(/(&|\?)no-linked-card(=true|\=false)/, '');
    const cardLinkUrl = window.url(window.routes.accountStartCardLink, {forward: forwardUrl, action: [action, mediaId].join('~')});
    $('#add-card-button').attr('href', cardLinkUrl);
};

export default noCard;
